import api from './api';

const eventoService = {
  getAll: async () => {
    const response = await api.get('/eventos');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/eventos/${id}`);
    return response.data;
  },

  create: async (eventoData) => {
    const response = await api.post('/eventos', eventoData);
    return response.data;
  },

  update: async (id, eventoData) => {
    const response = await api.put(`/eventos/${id}`, eventoData);
    return response.data;
  },

  updatePrecio: async (id, precio) => {
    const response = await api.put(`/eventos/${id}/precio`, { precio });
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/eventos/${id}`);
    return response.data;
  }
};

export default eventoService;
